import gql from 'graphql-tag';
const PAID_SEARCH_CAMPAIGN = gql`
  query paidSearchCampaign($orgId: ID!, $campaignId: ID!) {
    org(where: { id: $orgId }) {
      id
      paidSearchSummary {
        id
        paidSearchCampaigns(where: { id: $campaignId }) {
          id
          name
          status
          startDate
          endDate
          adProviderId
          data {
            id
            impressions
            clicks
            cost
            revenue
            cpc
            cpm
            spend
            ctr
            roas
            rawCost
            interactionRate
            conversions
            conversionRate
            phoneCalls
            byDate(orderBy: date_ASC) {
              keywords
              locations
              conversions
              clicks
              impressions
              ctr
              cost
              cpc
              cpm
              spend
              revenue
              conversionRate
              roas
              date
              xAxis
            }
          }
        }
      }
    }
  }
`;

export default PAID_SEARCH_CAMPAIGN;
